module.exports = __webpack_public_path__ + "static/media/XL.a438cb18.jpg";